<template>
  <div class="formc">
    <div class="formc-con">
      <el-form :model="data" :rules="rules" ref="elFormRef" inline-message scroll-to-error :scroll-into-view-options="{ behavior: 'smooth', block: 'center' }">
        <table class="el-table-s3">
          <tbody>
            <tr>
              <td class="table-label" width="285" height="40">
                <span>中共党员（包括预备党员）人数</span>
              </td>
              <td width="460">
                <div class="td-c1">
                  <el-form-item prop="numparm">
                    <el-input v-model.trim="data.numparm" />
                  </el-form-item>

                  <span>人</span>
                </div>
              </td>
              <td>
                <div class="td-c2">
                  <em class="color-999">不公示</em>
                </div>
              </td>
            </tr>

            <tr>
              <td class="table-label" width="285" height="40">
                <span>党组织建制</span>
              </td>
              <td width="460">
                <div class="td-c1">
                  <el-form-item prop="parins">
                    <el-radio-group v-model="data.parins">
                      <el-radio v-for="(item, index) of parinsOptions" :key="index" :value="item.value">{{ item.label }}</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </div>
              </td>
              <td>
                <div class="td-c2">
                  <em class="color-999">不公示</em>
                </div>
              </td>
            </tr>

            <tr>
              <td class="table-label" width="285" height="40">
                <span>法定代表人是否为党员</span>
              </td>
              <td width="460">
                <div class="td-c1">
                  <el-form-item prop="resparmsign">
                    <el-radio-group v-model="data.resparmsign">
                      <el-radio value="1">是</el-radio>
                      <el-radio value="2">否</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </div>
              </td>
              <td>
                <div class="td-c2">
                  <em class="color-999">不公示</em>
                </div>
              </td>
            </tr>

            <tr>
              <td class="table-label" width="285" height="40">
                <span>法定代表人是否为党组织书记</span>
              </td>
              <td width="460">
                <div class="td-c1">
                  <el-form-item prop="resparsecsign">
                    <el-radio-group v-model="data.resparsecsign">
                      <el-radio value="1">是</el-radio>
                      <el-radio value="2">否</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </div>
              </td>
              <td>
                <div class="td-c2">
                  <em class="color-999">不公示</em>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </el-form>
    </div>

    <div class="formc-btn">
      <el-button type="primary" color="#d1ab62" size="large" @click="save">保存</el-button>
      <el-button type="primary" color="#d1ab62" size="large" @click="emits('emit', 'gotoPage', 'center')">返回</el-button>
    </div>
  </div>
</template>

<script setup>
import { cloneDeep } from "lodash";
import { parinsOptions } from "./utils.js";

const props = defineProps({
  data: {
    type: Object,
    defaults() {
      return {};
    },
  },
});

const elFormRef = ref();

const data = ref({});

const rulesConfig = { required: true, trigger: ["blur", "change"], message: "不能为空" };

const rules = ref({
  numparm: [rulesConfig],
  parins: [rulesConfig],
  resparmsign: [rulesConfig],
  resparsecsign: [rulesConfig],
});

const save = () => {
  elFormRef.value.validate((isValid) => {
    if (isValid) {
      emits("emit", "submit", data.value);
    }
  });
};

const emits = defineEmits(["emit"]);

onMounted(() => {
  data.value = cloneDeep(props.data);
});
</script>

<style lang="scss" scoped>
.formc {
}
</style>
